import * as inputsStyles from "../inputs.module.scss"
import React from "react"
import { FieldErrors } from "react-hook-form/dist/types/errors"

type FormErrorProps = {
  errors: FieldErrors
  name: string
  type: string
  id?: string
  children?: React.ReactNode
}

type GlobalFormErrorProps = {
  show?: boolean
  className?: string
  children?: React.ReactNode
}

const FormError: React.FC<FormErrorProps> = ({ errors, name, type, id, children }) => {
  if (errors && errors[name] && errors[name].type === type) {
    return (
      <p role="alert" className={inputsStyles.formError} id={id || undefined}>
        {children}
      </p>
    )
  }
  return null
}

const GlobalFormError: React.FC<GlobalFormErrorProps> = ({ show = true, className = "", children }) => {
  if (!show || !children) {
    return null
  }

  return (
    <p role="alert" className={`${inputsStyles.formError} ${className}`.trim()}>
      {children}
    </p>
  )
}

export default FormError
export { GlobalFormError }
